const TWEMOJI_VERSION = '17.0.3';
const TWEMOJI_SCRIPT_URL = `https://cdn.jsdelivr.net/npm/@twemoji/api@${TWEMOJI_VERSION}/dist/twemoji.min.js`;
const TWEMOJI_ASSET_BASE = `https://cdn.jsdelivr.net/gh/jdecked/twemoji@${TWEMOJI_VERSION}/assets/`;
let twemojiPromise;
const emojiObservers = new WeakMap();

const loadTwemoji = () => {
  if (window.twemoji) return Promise.resolve(window.twemoji);

  if (!twemojiPromise) {
    twemojiPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.async = true;
      script.src = TWEMOJI_SCRIPT_URL;
      script.onload = () => resolve(window.twemoji);
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  return twemojiPromise;
};

const parseEmoji = (
  element,
  twemoji,
  { loading, singleMessage, onSingleEmoji }
) => {
  twemoji.parse(element, {
    base: TWEMOJI_ASSET_BASE,
    folder: 'svg',
    ext: '.svg',
    className: 'cw-emoji inline-block h-[1em] w-[1em] align-[-0.125em]',
    attributes: () => ({ loading, decoding: 'async' }),
  });

  const emojis = [...element.querySelectorAll('.cw-emoji')];
  emojis
    .slice(0, -1)
    .forEach(emoji => emoji.classList.add('cw-emoji--with-gap'));

  // Aceleres 2026-08-19: esta continua a ser a UNICA definicao de "a mensagem
  // e so um emoji" — quem precisa da resposta pergunta por aqui, em vez de
  // reimplementar a conta com uma expressao regular propria (que teria de
  // saber de modificadores de tom, ZWJ, variation selectors e bandeiras, e
  // divergiria desta na primeira diferenca). A bolha de emoji (Text/Index.vue)
  // liga-se por este mesmo caminho.
  const isEmojiOnlyMessage =
    singleMessage && emojis.length > 0 && !element.textContent.trim();
  const isSingleEmoji = isEmojiOnlyMessage && emojis.length === 1;
  const hasTwoEmojis = isEmojiOnlyMessage && emojis.length === 2;
  const hasThreeEmojis = isEmojiOnlyMessage && emojis.length === 3;

  if (isSingleEmoji) {
    emojis[0].classList.add('cw-emoji--single-message');
  }

  if (hasTwoEmojis) {
    emojis.forEach(emoji => emoji.classList.add('cw-emoji--double-message'));
  }

  if (hasThreeEmojis) {
    emojis.forEach(emoji => emoji.classList.add('cw-emoji--triple-message'));
  }

  onSingleEmoji?.(isSingleEmoji);
};

const renderEmojiNow = (element, options) => {
  loadTwemoji()
    .then(twemoji => parseEmoji(element, twemoji, options))
    .catch(() => {});
};

export const renderEmoji = (
  element,
  { loading = 'lazy', singleMessage = false, onSingleEmoji } = {}
) => {
  if (!element) return;

  emojiObservers.get(element)?.disconnect();

  const options = { loading, singleMessage, onSingleEmoji };
  if (
    element.classList.contains('emoji--item') &&
    typeof IntersectionObserver !== 'undefined'
  ) {
    const observer = new IntersectionObserver(
      entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;

        observer.disconnect();
        emojiObservers.delete(element);
        renderEmojiNow(element, options);
      },
      {
        root: element.closest('.emoji-item'),
        rootMargin: '120px',
      }
    );

    emojiObservers.set(element, observer);
    observer.observe(element);
    return;
  }

  renderEmojiNow(element, options);
};

export const twemojiDirective = {
  mounted: (element, binding) => {
    if (!binding.value?.disabled) renderEmoji(element, binding.value);
  },
  updated: (element, binding) => {
    if (!binding.value?.disabled) renderEmoji(element, binding.value);
  },
  unmounted: element => {
    emojiObservers.get(element)?.disconnect();
    emojiObservers.delete(element);
  },
};
